import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { secureRandom } from '../../utils/randomUtils';
import { isLocalhostEnvironment } from '../../utils/utils';
import { EntryBadBeatJackpotDisplay } from './entryBadBeatJackpotDisplay';
const USE_MOCK_DATA = isLocalhostEnvironment();
const MOCK_BAD_BEAT_JACKPOT_AMOUNT = Math.round(1000000 + secureRandom() * 15000000);
const BadBeatJackpotSchema = z.object({
    powerPlayerWinnableAmount: z.number()
});
function badBeatJackpotParser(str) {
    try {
        const parsed = JSON.parse(str);
        const valid = BadBeatJackpotSchema.parse(parsed);
        return valid;
    }
    catch {
        // don't set bad beat jackpot on error
    }
}
async function fetchBadBeatJackpot() {
    if (USE_MOCK_DATA) {
        return { powerPlayerWinnableAmount: MOCK_BAD_BEAT_JACKPOT_AMOUNT };
    }
    try {
        const response = await fetch('/api_bad_beat_jackpot.php');
        if (!response.ok) {
            return;
        }
        const jsonStr = await response.text();
        const newBadBeatJackpot = badBeatJackpotParser(jsonStr);
        return newBadBeatJackpot;
    }
    catch {
        // don't set bad beat jackpot on error
    }
}
export const EntryBadBeatJackpotContainer = () => {
    const { data: badBeatJackpot } = useQuery({ queryKey: ['bad-beat-jackpot'], queryFn: fetchBadBeatJackpot });
    if (!badBeatJackpot) {
        return null;
    }
    return _jsx(EntryBadBeatJackpotDisplay, { badBeatJackpotAmount: badBeatJackpot.powerPlayerWinnableAmount });
};
